const MILITARY_VETERAN = "Military Veteran";

export { MILITARY_VETERAN };
